<script lang="ts">
  import Heading from '$components/elements/Heading.svelte';
  import Subheading from '$components/elements/Subheading.svelte';
  import Companies from '$components/blocks/Companies.svelte';
  import Text from '$components/utils/Text.svelte';
</script>

<div class="about-us">
  <Heading textAlign="center"><Text key="page.about-us.heading" /></Heading>
  <Subheading textAlign="center"><Text key="page.about-us.sub-heading" /></Subheading>
  <Companies />
</div>

<style lang="scss">
  .about-us {
    width: 100%;
    background-color: $color-light-gray;
    padding: 65px 0 0;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
</style>
